import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, TopShop } from "@faire/design-tokens";
import { formatMoney } from "@faire/web--source/common/money";
import { Opacity } from "@faire/web--source/slate/Color";
import { TrophyIcon } from "@faire/web--source/slate/icons/Trophy";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { eventsThemeColors } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { ThemeProvider } from "@faire/web--source/slate/Theme/ThemeProvider";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { TransparencyOverlay } from "@faire/web--source/ui/TransparencyOverlay";
import * as React from "react";
import styled, { css } from "styled-components";
import { BrandAvatar } from "@faire/retailer/components/BrandAvatar";
import { InfoWrapper } from "@faire/retailer/components/TopSearch/ResultDropdown/__internal__/Styled";
import { EventsStore } from "@faire/retailer-visitor-shared/stores/domain/Events/shared/EventsStore";
import { useTopShopVisibility } from "../../TopShop/useTopShopVisibility";
var OVERLAY_BACKGROUND_COLOR = "linear-gradient(0deg, rgba(0, 0, 0, 3%), rgba(0, 0, 0, 3%))";
var WRAPPER_HEIGHT = getSpacing("7x");
var WRAPPER_HEIGHT_SMALL = getSpacing("6x");
export var ResultDropdownImageItem = function(param) {
    var suggestion = param.suggestion, selected = param.selected, isProduct = param.isProduct, index = param.index, onHover = param.onHover, onMouseLeave = param.onMouseLeave, onClick = param.onClick, shouldEnableSuggestionsImpressionAllocationV2 = param.shouldEnableSuggestionsImpressionAllocationV2;
    var _suggestion_searchData;
    var _suggestion_searchData1 = suggestion.searchData, profile_image = _suggestion_searchData1.profile_image, squared_image = _suggestion_searchData1.squared_image, name = _suggestion_searchData1.name, image = _suggestion_searchData1.image, is_highlighted_brand_for_promotional_event = _suggestion_searchData1.is_highlighted_brand_for_promotional_event, wholesale_price = _suggestion_searchData1.wholesale_price, brand_name = _suggestion_searchData1.brand_name;
    var onClickSuggestion = function() {
        onClick(suggestion, false);
    };
    var isTopShopContentVisibleForBrand = useTopShopVisibility((_suggestion_searchData = suggestion.searchData) === null || _suggestion_searchData === void 0 ? void 0 : _suggestion_searchData.is_top_shop).isTopShopContentVisibleForBrand;
    var _wholesale_price_amount_cents;
    var defaultSubtitle = /*#__PURE__*/ _jsx(_Fragment, {
        children: isProduct ? /*#__PURE__*/ _jsx(PriceWrapper, {
            children: wholesale_price && ((_wholesale_price_amount_cents = wholesale_price.amount_cents) !== null && _wholesale_price_amount_cents !== void 0 ? _wholesale_price_amount_cents : 0) > 0 ? getPriceMessage(wholesale_price, brand_name !== null && brand_name !== void 0 ? brand_name : "") : getPriceMessageNoPrice(brand_name !== null && brand_name !== void 0 ? brand_name : "")
        }) : /*#__PURE__*/ _jsxs(Row, {
            children: [
                isTopShopContentVisibleForBrand ? /*#__PURE__*/ _jsx(StyledTrophyIcon, {
                    active: true,
                    fontSize: "medium"
                }) : null,
                /*#__PURE__*/ _jsx(PriceWrapper, {
                    children: isTopShopContentVisibleForBrand ? /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "ORPA1Y",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Top Shop"
                                }
                            ]
                        })
                    }) : null
                })
            ]
        })
    });
    var displayImage = isProduct ? image : profile_image !== null && profile_image !== void 0 ? profile_image : squared_image;
    var getBorderColor = function() {
        if (is_highlighted_brand_for_promotional_event) {
            var _eventsThemeColors_faireMarket_decorative2;
            return (_eventsThemeColors_faireMarket_decorative2 = eventsThemeColors.faireMarket.decorative2) !== null && _eventsThemeColors_faireMarket_decorative2 !== void 0 ? _eventsThemeColors_faireMarket_decorative2 : undefined;
        } else if (isTopShopContentVisibleForBrand) {
            return TopShop.shade.green;
        }
        return undefined;
    };
    return /*#__PURE__*/ _jsx("li", {
        children: /*#__PURE__*/ _jsx(Wrapper, {
            $selected: selected,
            onMouseLeave: function() {
                onMouseLeave();
                onHover(-1);
            },
            onMouseEnter: function() {
                return onHover(index);
            },
            to: suggestion.url,
            onClick: onClickSuggestion,
            tabIndex: -1,
            $height: shouldEnableSuggestionsImpressionAllocationV2 ? WRAPPER_HEIGHT_SMALL : WRAPPER_HEIGHT,
            children: /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                style: {
                    flex: 1,
                    position: "relative",
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ _jsx(ThemeProvider, {
                        theme: EventsStore.get().nextOrActiveEventTheme,
                        children: /*#__PURE__*/ _jsxs(BrandIconWrapper, {
                            $isTopShop: isTopShopContentVisibleForBrand,
                            children: [
                                /*#__PURE__*/ _jsx(BrandIcon, {
                                    size: "smaller",
                                    image: displayImage,
                                    isProduct: isProduct,
                                    showEventIcon: is_highlighted_brand_for_promotional_event,
                                    borderColor: getBorderColor()
                                }),
                                isProduct ? /*#__PURE__*/ _jsx(StyledOverlay, {
                                    color: OVERLAY_BACKGROUND_COLOR
                                }) : null
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(InfoWrapper, {
                        children: [
                            /*#__PURE__*/ _jsx(NamePara, {
                                children: name
                            }),
                            defaultSubtitle
                        ]
                    })
                ]
            })
        })
    });
};
var getPriceMessage = function(wholesale_price, brand_name) {
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "cBbr76",
        defaultMessage: [
            {
                type: 1,
                value: "priceMoney"
            },
            {
                type: 0,
                value: " by "
            },
            {
                type: 1,
                value: "brandCompanyName"
            }
        ],
        values: {
            priceMoney: formatMoney({
                money: wholesale_price,
                omitCentsIfZero: true
            }),
            brandCompanyName: brand_name
        }
    });
};
var getPriceMessageNoPrice = function(brand_name) {
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "mnvDDV",
        defaultMessage: [
            {
                type: 0,
                value: "by "
            },
            {
                type: 1,
                value: "brandCompanyName"
            }
        ],
        values: {
            brandCompanyName: brand_name
        }
    });
};
var StyledOverlay = styled(TransparencyOverlay).withConfig({
    componentId: "sc-6d733fc9-0"
})([
    "border-radius:2px;"
]);
var Wrapper = styled(Link).withConfig({
    componentId: "sc-6d733fc9-1"
})([
    "display:flex;position:relative;justify-content:space-between;align-items:center;cursor:pointer;height:",
    ";background-color:",
    ";&:focus{background-color:",
    ";}padding:",
    ";",
    "{padding:",
    ";}"
], function(param) {
    var $height = param.$height;
    return $height;
}, function(param) {
    var $selected = param.$selected;
    return $selected ? Core.surface.subdued + Opacity.O_50 : null;
}, Core.surface.subdued + Opacity.O_50, getSpacing("1x", "2x"), responsiveMediaQueries.tabletAndAbove, getSpacing(0, 0, 0, "2x"));
var BrandIcon = styled(BrandAvatar).withConfig({
    componentId: "sc-6d733fc9-2"
})([
    "border-radius:",
    ";border:",
    ";"
], function(props) {
    return props.isProduct ? "0" : "50%";
}, function(props) {
    return props.isProduct ? "none" : undefined;
});
var BrandIconWrapper = styled.div.withConfig({
    componentId: "sc-6d733fc9-3"
})([
    "position:relative;",
    ""
], function(param) {
    var $isTopShop = param.$isTopShop;
    return $isTopShop ? css([
        "margin-left:-3px;"
    ]) : null;
});
var PriceWrapper = styled(Typography).attrs({
    truncate: true,
    color: Core.text.subdued
}).withConfig({
    componentId: "sc-6d733fc9-4"
})([
    "width:calc(100% - 20px);"
]);
var NamePara = styled(Typography).attrs({
    truncate: true
}).withConfig({
    componentId: "sc-6d733fc9-5"
})([
    "width:calc(100% - 20px);"
]);
var StyledTrophyIcon = styled(TrophyIcon).withConfig({
    componentId: "sc-6d733fc9-6"
})([
    "margin:1px 2px 0 -3.5px;"
]);
